import { Component, HostBinding, OnInit, ViewChild, ViewRef } from '@angular/core';

import { Observable, Subject } from 'rxjs';

import { LayoutHostDirective } from '../../components/layout-host.directive';
import {
  AbstractContainer,
  AbstractControl,
  ControlDataModel,
  ControlLayoutModel,
  ControlViewModel
} from '../../types/control.types';
import { DynamicFormDataConfig } from '../../types/designer.types';
import {
  ControlShared,
  ControlTranslate,
  moveDownViewRef,
  moveUpViewRef,
  removeControl,
  translateControl2ControlDataModel
} from '../../utils';

/**
 * @description æ½è±¡æ§ä»¶å®¹å¨
 *
 * @export
 */
@Component({
  selector: 'df-abstract-control-container',
  templateUrl: './abstract-control-container.component.html',
  styleUrls: ['./abstract-control-container.component.css']
})
export class AbstractControlContainerComponent<T extends ControlViewModel> implements AbstractContainer<T>, OnInit {
  viewOnly?: boolean;
  dataConfig: DynamicFormDataConfig = { formCode: '' };
  valid: boolean = true;

  type: string;
  isDesign: boolean;
  get model(): T {
    return this._model;
  }
  set model(model: T) {
    this._model = model;
    this.hidden = this.model.isHidden;
  }
  // model: T;
  children: AbstractControl<ControlViewModel>[] = [];
  parent: AbstractControl<ControlViewModel>;
  isContainer: boolean = true;
  controlTranslate: ControlTranslate;
  controlShared: ControlShared;
  hidden: boolean;

  private _model: T;

  ngOnInit(): void {}

  setModelValue(value: string): void {
    this.model[`value`] = value;
  }
  getModelValue(): string {
    return this.model[`value`];
  }

  get designHostClass(): string {
    return this.model ? this.model.class : '';
  }

  @HostBinding()
  get class(): string {
    const c = this.model ? this.model.class : '';
    return c + (this.isDesign ? ' design' : '') + this.hiddenClass;
  }

  get hiddenClass(): string {
    if (this.hidden && !this.isDesign) {
      return ' hidden ';
    }
    return '';
  }

  get propertyValueChanged$(): Observable<{ name: string; value: any }> {
    return this._propertyValueChanged.asObservable();
  }

  @ViewChild(LayoutHostDirective) layoutHost: LayoutHostDirective;
  private _propertyValueChanged: Subject<{ name: string; value: any }> = new Subject<{ name: string; value: any }>();

  constructor() {}

  propertyValueChanged(name: string, value: any): void {
    this._propertyValueChanged.next({ name, value });
  }

  bindEvents(): void {}

  validate(): void {}

  addControls(controls: Array<ControlLayoutModel>): Observable<AbstractControl<ControlViewModel>[]> {
    const sub = new Subject<AbstractControl<ControlViewModel>[]>();
    this.controlTranslate.sendLoadComponentModel({
      layoutModel: controls,
      dynamicControlContainer: this,
      isDesign: this.isDesign,
      result: (c: AbstractControl<ControlViewModel>[]) => {
        if (!this.children) {
          this.children = [];
        }
        c.forEach((s) => {
          s.parent = this;
        });
        this.children.push(...c);
      }
    });
    return sub;
  }
  addControl(control: ControlLayoutModel): Observable<AbstractControl<ControlViewModel>> {
    const sub = new Subject<AbstractControl<ControlViewModel>>();
    this.controlTranslate.sendLoadComponentModel({
      layoutModel: control,
      dynamicControlContainer: this,
      isDesign: this.isDesign,
      result: (c: AbstractControl<ControlViewModel>) => {
        if (!this.children) {
          this.children = [];
        }
        c.parent = this;
        this.children.push(c as AbstractControl<ControlViewModel>);
      }
    });
    return sub;
  }

  removeControl(index?: number) {
    this.controlTranslate.sendControlRemoved(this.children[index]);
    removeControl(index, this.layoutHost, this.children);
  }

  moveUpView(hostView: ViewRef): void {
    moveUpViewRef(hostView, this.layoutHost, this.children);
  }

  moveDownView(hostView: ViewRef): void {
    moveDownViewRef(hostView, this.layoutHost, this.children);
  }

  getDataModel(): ControlDataModel {
    const dataModel = translateControl2ControlDataModel(this);
    for (const c of this.children) {
      dataModel.children.push(c.getDataModel());
    }
    return dataModel;
  }
}
